/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_our_world_class_teachers_come_from_multitude_of_educational_backgrounds_and_experiences_and_to: Phrase =locale => {
  const en = `Our world class teachers come from a multitude of educational backgrounds and experiences, and teach to a variety of individuals just like you!`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Nuestros excelentes profesores provienen de diversos ámbitos educativos y experiencias, ¡y están capacitados para enseñar a personas como tú de manera excepcional!`,
  };
  return phrases[locale] || en;
};
            